// extracted by mini-css-extract-plugin
export default {"rating":"mw-z","numberOfStars":"nw-z","count":"ow-z","barGraphSpacing":"pw-z","barGraph":"qw-z"};